import { createFileRoute, Link } from '@tanstack/react-router';
import { useState } from 'react';

import { ResetPasswordForm } from '~/components/landing/ResetPasswordForm';

export const Route = createFileRoute('/$slug/auth/reset-password')({
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const { slug } = Route.useParams();
  const [status, setStatus] = useState<'form' | 'success' | 'expired'>('form');

  // Extract token from URL search params
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  if (!token) {
    return (
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="w-full max-w-sm text-center space-y-4">
          <p className="text-sm text-red-600">Invalid reset link. No token provided.</p>
          <Link
            to="/$slug/auth"
            params={{ slug }}
            className="text-sm text-blue-600 hover:underline"
          >
            Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="w-full max-w-sm text-center space-y-4">
          <h2 className="text-xl font-semibold">Password Reset Successfully</h2>
          <p className="text-sm text-gray-600">Your password has been updated. You can now sign in with your new password.</p>
          <Link
            to="/$slug/auth"
            params={{ slug }}
            className="inline-block rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            Sign in
          </Link>
        </div>
      </div>
    );
  }

  if (status === 'expired') {
    return (
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="w-full max-w-sm text-center space-y-4">
          <h2 className="text-xl font-semibold">Link Expired</h2>
          <p className="text-sm text-gray-600">This reset link has expired. Please request a new one.</p>
          <Link
            to="/$slug/auth"
            params={{ slug }}
            className="text-sm text-blue-600 hover:underline"
          >
            Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <ResetPasswordForm
        token={token}
        onSuccess={() => setStatus('success')}
        onExpired={() => setStatus('expired')}
      />
    </div>
  );
}
